var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"unstyled-list",class:_vm.display},_vm._l((_vm.results),function(result){return _c('li',{key:result.Name},[_c('CatalogProduct',{attrs:{"result":result,"catalog":_vm.catalog}})],1)}),0)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-321afcde","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/SearchResults.vue
// module id = uJrC
// module chunks = 1